import { Http } from "@/util";

// 获取培训资料列表
export function getTrainingMaterialsList(params) {
  return Http.post("/admin/newtraining/materials/list", params);
}

// 保存或更新培训资料
export function saveTrainingMaterials(data) {
  return Http.post("/admin/newtraining/materials/save", data);
}

// 删除培训资料
export function deleteTrainingMaterials(trainMaterialsId) {
  return Http.get(`/admin/newtraining/materials/delete`, { trainMaterialsId });
}

// 获取考试详情
export function getTrainMaterials(materialId) {
  return Http.get("/admin/newtraining/materials/detail", { materialId });
}

// 获取考试列表
export function getTrainingExamList(params) {
  return Http.post("/admin/newtraining/exam/list", params);
}

// 保存或更新考试
export function saveTrainingExam(data) {
  return Http.post("/admin/newtraining/exam/save", data);
}

// 删除考试
export function deleteTrainingExam(trainExamId) {
  return Http.post(`/admin/newtraining/exam/delete`, { trainExamId });
}

// 获取考试详情
export function getTrainExam(trainExamId) {
  return Http.get("/admin/newtraining/exam/detail", { trainExamId });
}

// 获取培训任务列表
export function getTrainingList(params) {
  return Http.post("/admin/newtraining/training/list", params);
}

// 保存或更新培训任务
export function saveTraining(data) {
  return Http.post("/admin/newtraining/training/save", data);
}

// 删除培训任务
export function deleteTraining(trainingId) {
  return Http.get(`/admin/newtraining/training/delete`, { trainingId });
}

// 为司机批量创建培训任务
export function createDriverTraining(params) {
  return Http.post("/admin/newtraining/driver/create", params);
}

// 获取司机培训列表
export function getDriverTrainingList(trainingId) {
  return Http.get("/admin/newtraining/driver/list", { trainingId });
}
